import { decompressFromEncodedURIComponent } from 'lz-string';

export default function (base64) {
  try {
    let decoded = decompressFromEncodedURIComponent(base64);
    if (decoded === '') {
      decoded = atob(base64);
    }
    return JSON.parse(decoded);
  } catch (e) {
    return false;
  }
}
